import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { ApiCallService } from "src/app/core/services/api-call-service";
import { SnackbarCollection } from "src/app/core/services/snackbar.service";
import { TranslateDynamicText } from "src/app/shared/pipes/dynamic-translation.pipe";
import { MilestoneCommonCheckBoxComponent } from "../milestone-common-check-box/milestone-common-check-box.component";

interface ExtractedData {
  id: number;
  name: string;
}

@Component({
  selector: "app-challenges-reward-config",
  templateUrl: "./challenges-reward-config.component.html",
  styleUrls: ["./challenges-reward-config.component.css"],
})
export class ChallengesRewardConfigComponent implements OnInit {
  rewardTypes = [
    {
      displayName: "Reward Points",
      type: "LOYALTY_POINTS",
      description:
        "Reward Points are awarded upon completing a level, recognizing achievements and motivating further progress.",
    },
    {
      displayName: "Award Badges",
      type: "BADGE",
      description:
        "Badges are awarded upon completing a level, recognizing achievements and motivating further progress.",
    },
    {
      displayName: "Award Offers/Coupons",
      type: "OFFER",
      description:
        "Offers are awarded upon completing a level, recognizing achievements and motivating further progress.",
    },
  ];
  selectedRewards: { [key: string]: boolean } = {};
  numberOfCoins = 0;
  offerList;
  badgeList;
  badgeSelected = [];
  offerSelected = [];
  @Output() milestoneConfigFunction = new EventEmitter<any>();
  @ViewChild("offerSelection")
  offerSelection: MilestoneCommonCheckBoxComponent;
  @ViewChild("badgeSelection")
  badgeSelection: MilestoneCommonCheckBoxComponent;
  @Input() isEdit: boolean;
  @Input() rewardData: any;
  @Input() status;

  constructor(
    private apiCall: ApiCallService,
    private _snackBar: SnackbarCollection,
    private _i18nDynamicTranslate: TranslateDynamicText
  ) {}

  async ngOnInit(): Promise<void> {
    await this.getallOffer();
    await this.getAllBadges();
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log(this.rewardData, this.isEdit);
    if (changes.rewardData) {
      this.initializeRewards();
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.initializeRewards();
    });
  }

  initializeRewards() {
    if (this.isEdit || this.rewardData) {
      this.rewardData?.rewardData?.forEach((reward) => {
        this.selectedRewards[reward.type] = true;
        if (reward.type == "LOYALTY_POINTS") {
          this.numberOfCoins = reward.value;
        } else if (reward.type == "OFFER") {
          this.offerSelected = reward.ids;
        } else if (reward.type == "BADGE") {
          this.badgeSelected = reward.ids;
        }
      });
    } else {
      this.rewardTypes.forEach((reward) => {
        this.selectedRewards[reward.type] = false;
      });
    }
  }

  async getallOffer(): Promise<void> {
    await this.apiCall.getAllOfferList().subscribe(
      (response) => {
        if (response["message"] === "success") {
          this.offerList = response["body"].offers.filter(
            (offer) => offer.status === "Sent" || offer.status === "Draft"
          );
          this.offerList = this.extractNameAndId(this.offerList, "offerName");
        }
      },
      (err) => {
        this.offerList = null;
        this._snackBar.openSnackBar(
          this._i18nDynamicTranslate.transform("Error fetching offers", [
            "POS_PAGE",
          ]),
          2000
        );
        console.log(err);
      }
    );
  }

  async getAllBadges(): Promise<void> {
    await this.apiCall.getBadgesByMerchantId().subscribe(
      (response) => {
        if (response["message"] === "success") {
          this.badgeList = response["body"];
          this.badgeList = this.extractNameAndId(this.badgeList, "name");
        }
      },
      (err) => {
        this.badgeList = null;
        this._snackBar.openSnackBar(
          this._i18nDynamicTranslate.transform("Error fetching badges", [
            "POS_PAGE",
          ]),
          2000
        );
        console.log(err);
      }
    );
  }

  extractNameAndId(data, keyName): ExtractedData[] {
    if (data) {
      return data.map((item) => ({
        id: item.id,
        name: item[keyName],
      }));
    }
  }

  getSelectedRewards() {
    return this.rewardTypes.filter(
      (reward) => this.selectedRewards[reward.type]
    );
  }

  selectChallengeType(value) {
    // if (value === "exit") {
    //   this.milestoneConfigFunction.emit(value);
    //   return;
    // }
    const selectedKeys = Object.keys(this.selectedRewards).filter(
      (key) => this.selectedRewards[key]
    );
  
    // Validation
    for (const key of selectedKeys) {
      if (key === "LOYALTY_POINTS" && (!this.numberOfCoins || this.numberOfCoins <= 0)) {
        // Show error or return
        this.showValidationError("Please enter a valid number of coins.", 'numberOfCoinsErrorField');
        return;
      }
  
      if (key === "OFFER" && (!this.offerSelection?.selectedIds?.length)) {
        this.showValidationError("Please select at least one offer.", 'offerErrorField');
        return;
      }
  
      if (key === "BADGE" && (!this.badgeSelection?.selectedIds?.length)) {
        this.showValidationError("Please select at least one badge.", 'badgeErrorField');
        return;
      }
    }

    const rewardArray = Object.keys(this.selectedRewards)
      .filter((key) => this.selectedRewards[key]) // Only include keys with a true value
      .map((key) => ({
        type: key,
        value: this.getData(key),
        ids: this.getIds(key),
      }));
    let data = {
      nextView: "summary",
      isExit: value === "exit" ? true : false,
      configData: {
        rewardData: rewardArray,
      },
    };
    this.milestoneConfigFunction.emit(data);
  }

  showValidationError(message: string, type: string) {
    document.getElementById(type).innerHTML =
    this._i18nDynamicTranslate.transform(
      message,
      ["SHARED_PAGE"]
    );
  }

  getData(key) {
    if (key === "LOYALTY_POINTS") {
      return this.numberOfCoins;
    }
    if (key === "OFFER") {
      return this.offerSelection.selectedData;
    }
    if (key === "BADGE") {
      return this.badgeSelection.selectedData;
    }
  }

  getIds(key) {
    if (key === "LOYALTY_POINTS") {
      return null;
    }
    if (key === "OFFER") {
      return this.offerSelection.selectedIds;
    }
    if (key === "BADGE") {
      return this.badgeSelection.selectedIds;
    }
  }

  stringInputKeyDown(event: KeyboardEvent, maxLength: number) {  
    this.showValidationError("", "numberOfCoinsErrorField");
    const allowedKeys = ["Backspace", "ArrowLeft", "ArrowRight", "Tab", "Delete"];
  
    // Allow Ctrl/Command + A, C, X, V
    if (
      (event.ctrlKey || event.metaKey) &&
      ["a", "c", "x", "v"].includes(event.key.toLowerCase())
    ) {
      return;
    }
  
    const key = event.key;
  
    // Allow only digits and allowed control keys
    if (!/^\d$/.test(key) && !allowedKeys.includes(key)) {
      event.preventDefault();
      return;
    }
  
    const inputValue = (event.target as HTMLInputElement).value;
    if (inputValue.length >= maxLength && !allowedKeys.includes(key)) {
      event.preventDefault();
    }
  }

  badgeSelectedEvent(event){
    if(event.length > 0){
      this.showValidationError("", "badgeErrorField");
    } else{
      this.showValidationError("Please select at least one badge.", 'badgeErrorField');
    }
  }

  offerSelectedEvent(event){
    if(event.length > 0){
      this.showValidationError("", "offerErrorField");
    } else{
      this.showValidationError("Please select at least one offer.", 'offerErrorField');
    }
  }
}
